import React, { useEffect, useState } from "react";
import Creatable from "react-select/creatable";
import { applyInputRule, checkInputRule } from "../../utils/inputRules";

const object = [
  { label: "Python", value: "python" },
  { label: "Java", value: "java" },
  { label: "C++", value: "c++" },
  { label: "C#", value: "c#" },
  { label: "Html", value: "html" },
  { label: "Css", value: "css" },
  { label: "JavaScript", value: "javascript" },
  { label: "Node", value: "node" },
  { label: "React", value: "react" },
  { label: "Angular", value: "angular" },
];

const colourStyles = {
  menu: (provided) => ({ ...provided, zIndex: 9999 }),
};

function normalizeSkill(value) {
  return String(value || "")
    .trim()
    .toLowerCase();
}

function dedupeSkillLabels(labels) {
  var seen = {};
  var out = [];
  (labels || []).forEach(function (label) {
    var trimmed = String(label || "").trim();
    var key = normalizeSkill(trimmed);
    if (!key || seen[key]) {
      return;
    }
    seen[key] = true;
    out.push(trimmed);
  });
  return out;
}

const SelectSkills = (props) => {
  const [selectedOption, setSelectedOption] = useState([]);

  const other_object = (props.skills || []).map((skill) => {
    return { label: skill, value: skill };
  });

  const handleChange = (data) => {
    const data_map = dedupeSkillLabels(
      (data || []).map(function (e) {
        return e.label;
      })
    );

    props.setUser((prev) => {
      return { ...prev, skills: data_map };
    });

    setSelectedOption(
      data_map.map(function (skill) {
        return { label: skill, value: skill };
      })
    );
  };

  const isValidNewOption = (inputValue, selectValue) => {
    var key = normalizeSkill(inputValue);
    if (!key || checkInputRule("skill", inputValue, "Skill")) {
      return false;
    }
    var alreadySelected = (selectValue || []).some(function (opt) {
      return (
        normalizeSkill(opt.label) === key || normalizeSkill(opt.value) === key
      );
    });
    if (alreadySelected) {
      return false;
    }
    var alreadyInList = object.some(function (opt) {
      return (
        normalizeSkill(opt.label) === key || normalizeSkill(opt.value) === key
      );
    });
    return !alreadyInList;
  };

  const DropdownIndicator = () => null;

  useEffect(() => {
    props.skills
      ? setSelectedOption(other_object)
      : setSelectedOption(selectedOption);
  }, [props.skills]);

  return (
    <div>
      <Creatable
        styles={colourStyles}
        onChange={handleChange}
        options={object}
        value={selectedOption}
        isMulti
        isClearable
        name="colors"
        className="basic-multi-select"
        classNamePrefix="select"
        allowCreateWhileLoading
        isValidNewOption={isValidNewOption}
        onInputChange={function (inputValue, meta) {
          return meta && meta.action === "input-change"
            ? applyInputRule("skill", inputValue)
            : inputValue;
        }}
        placeholder="Type a skill, e.g. React.js"
        formatCreateLabel={function (inputValue) {
          return 'Add "' + inputValue + '"';
        }}
        noOptionsMessage={function () {
          return "Skill already added or not available";
        }}
        components={{ DropdownIndicator }}
      />
    </div>
  );
};

export default SelectSkills;
